export enum CategoryLabelMap {
    "RelatedMarkets" = "filterby-market",
    "RelatedExpertise" = "filterby-expertise",
    "RelatedLocations" = "filterby-location",
    "OtherTags" = "filterby-other"
  }